/* eslint-disable max-len */
/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';

const orgHierarchyandProcessFlowAPI = async (
  selectedYear: string,
  chartType: string = '',
  data: any = undefined
): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const companyID = useCompanyStore.getState().companyId;

  try {
    const response = await axios.request({
      method: CRUDMethods.GET,
      // url: `${API_BASE_URL}${API_ENDPOINT_JSON.CONFIGURATOR.orgHierarchyChart}/${companyID}/${selectedYear}/${chartType}`,
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.CONFIGURATOR.orgHierarchyChart}${
        chartType === 'processFlow'
          ? `${API_ENDPOINT_JSON.CONFIGURATOR.processFlow}/`
          : '/'
      }${companyID}/${selectedYear}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {},
      data: data ?? {}
    });

    return response.data.data;
  } catch (err) {
    console.log('err:', err);
  }
};

export default orgHierarchyandProcessFlowAPI;
